module.exports = __webpack_public_path__ + "img/104.b8354112.jpg";